// extracted by mini-css-extract-plugin
export default {"block":"ArrowButton_block__0vfAh"};